import type React from "react";
import { ReactComponent as Svg } from "./assets/arrow-right-circle.svg";
import * as styles from "./Icon.module.scss";

type ArrowRightProps = React.SVGProps<SVGSVGElement>;

export const ArrowRight = ({ className, ...props }: ArrowRightProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
